<div *ngIf="style === VideoHeaderStyle.ReplayHighlights" class="video-type-switch">
  <div class="switch-button" [class.active]="selectedVideoType === VideoSubType.Highlight"
       (click)="onSwitchClick(VideoSubType.Highlight)">Highlights
  </div>
  <div class="switch-button" [class.active]="selectedVideoType === VideoSubType.Replay"
       (click)="onSwitchClick(VideoSubType.Replay)">Replay
  </div>
</div>
<div *ngIf="streamStatus && streamStatusColor"
     class="status-chip"
     [style.background-color]="streamStatusColor">
  {{ streamStatus }}
</div>
<div class="video-container" *ngIf="video">
  <lib-video-player
    [video]="video"
    [paywall]="true"
    [autostart]="false"
    [showAd]="true"
    [user]="userService.currentUser"
    [trackingInfo]="trackingInfo"
  ></lib-video-player>
</div>
<div *ngIf="!video && youtubeUrl">
  <iframe
    loading="lazy"
    class="user-select-disabled video-container"
    allowfullscreen="true"
    frameborder="0"
    [src]="youtubeUrl"
  ></iframe>
</div>
<span class="title" *ngIf="content.title">{{ content.title }}</span>
